import { Component, OnInit, OnDestroy, Input, Output, NgZone } from '@angular/core';
// ngrx store
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
// services
import { EventsService } from '../../../booking/services/events.service';
import { LoginService } from '../../services/login.service';
// models
import { AppState } from '../../../booking/models/app-state.interface';
// globals
import { EMAIL_PATTERN } from '../../../shared/globals';

@Component({
  selector: 'app-email-check',
  templateUrl: './email-check.component.html',
  styleUrls: ['./email-check.component.scss']
})
export class EmailCheckComponent implements OnInit, OnDestroy {

  private _verifyEmailSubscription: Subscription;
  private _storeSubscription: Subscription;

  public isUser: Boolean = false;
  public userLoggedIn: Boolean = false;
  public visibleSection = 'login';
  public showEmailLoader: Boolean = false;
  public userEmail: string;
  public emailPattern = EMAIL_PATTERN;
  public userNotFound: Boolean = false;

  constructor(
    private _appStore: Store<AppState>,
    private _loginService: LoginService,
    private _eventsService: EventsService,
    private zone: NgZone
  ) { }

  ngOnInit() {

    this.visibleSection = 'login';

    this._storeSubscription = this._appStore.select('userReducer')
      .subscribe((user: any) => {
        this.zone.run(() => {
          if (user.userDetails.userLoggedIn) {
            this.showEmailLoader = false;
            this.isUser = true;
          } else if (!user.userDetails.userLoggedIn) {
            this.visibleSection = 'login';
          }
        });
      });

    this._verifyEmailSubscription = this._loginService.validateUserSubject$
      .subscribe(res => {

        this.zone.run(() => {

          this._appStore.dispatch({ type: 'UPDATE_USER_STATUS', payload: res.verifyCustomerStatus });

          // if user has password go to login panel
          // else show error
          if (res.verifyCustomerStatus === 1) {
            this.showEmailLoader = false;
            this.isUser = true;
            this._loginService.updateUserEmail(this.userEmail);
          } else {
            this.userNotFound = true;
            this.showEmailLoader = false;
          }

        });

      });

  }

  goBack(e) {
    this._eventsService.goToPanel('prev');
  }

  handleSubmitEmailCheck(value, e) {
    e.preventDefault();
    this.showEmailLoader = true;
    this.userEmail = value.email;
    this._loginService.validateEmail(this.userEmail);
  }

  userActive(event) {
    this.isUser = event;
    this.visibleSection = 'login';
  }

  ngOnDestroy() {
    this._verifyEmailSubscription.unsubscribe();
    this._storeSubscription.unsubscribe();
  }

}
